import React, { useState, useEffect } from 'react';
import styles from './textSlider.module.scss';
import { loaderSteps } from '../static.loaderData'

function TextSlider() {

  const [titleCounter, setTitleCounter] = useState(0)

  useEffect(() => {
    if (titleCounter < loaderSteps.length -1) {
      setTimeout(() => setTitleCounter(titleCounter + 1), 2500);
    } else {
      setTitleCounter(loaderSteps.length - 1)
    }
  });

  return (
    <div className={styles.container_aboutLoader}>
        {titleCounter === 0 && <div className={styles.container_aboutLoader_item}>{loaderSteps[titleCounter].title}</div>}
        {titleCounter === 1 && <div className={styles.container_aboutLoader_item}>{loaderSteps[titleCounter].title}</div>}
        {titleCounter === 2 && <div className={styles.container_aboutLoader_item}>{loaderSteps[titleCounter].title}</div>}
        {titleCounter === 3 && <div className={styles.container_aboutLoader_item}>{loaderSteps[titleCounter].title}</div>}
        {titleCounter === 4 && <div className={styles.container_aboutLoader_item}>{loaderSteps[titleCounter].title}</div>}
        {titleCounter === 5 && <div className={styles.container_aboutLoader_last}>{loaderSteps[titleCounter].title}</div>}
    </div>
  );
}

export default TextSlider;
